import { Link } from 'react-router';
import { APP_NAME } from '@vuokramani/shared';
import logo from '../assets/logo.png';
import logoDark from '../assets/logo-tumma.png';
import s from './shell.module.css';

/** Pieni merkki (talo ja valaistu ovi): puhelimen yläpalkki ja selaimen välilehti. */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg className={s.brandMark} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#1d4950" />
      <path
        d="M8 25V12.5L16 7l8 5.5V25"
        fill="none"
        stroke="#9fd0cf"
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      <rect x="13.2" y="16" width="5.6" height="9" rx="1" fill="#e9c46a" />
    </svg>
  );
}

/**
 * Logo. Kaksi kuvaa: tumma teksti vaalealle pohjalle ja vaalea tummalle.
 * CSS valitsee teeman ja paikan mukaan (sivupaneeli on aina tumma).
 */
export function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className={s.brand} aria-label={APP_NAME}>
      <img className={s.logoLight} src={logo} alt="" height={40} />
      <img className={s.logoDark} src={logoDark} alt="" height={40} />
    </Link>
  );
}
